//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../../library/umum";

export default {
  data() {
    return {
        listVisi: [],
        listData: [],
        listKegiatan: [],

        page_limit: 8,
        // $store.state.page_first_perpus: 1,
        // $store.state.page_last_perpus: 0,
        cari_value: "",

        fotoObj : null,
        fotoIndex : 0,
        mFoto : false,

        UMUM: UMUM
    };
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_PERPUSTAKAAN + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.$store.state.page_first_perpus,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              des_kel : this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.listData = res_data.data;
              this.$store.state.page_last_perpus = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    cari_data: function() {
      this.$store.state.page_first_perpus = 1;
      this.getView();
    },
    indexing : function(index){
        var idx = ((this.$store.state.page_first_perpus-1)*this.page_limit)+index
        return idx
    },
    getFoto(){
      fetch(this.$store.state.url.URL_CNT_DESA_PERPUSTAKAAN + "list6", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          }
      })
          .then(res => res.json())
          .then(res_data => {
              this.listFoto = res_data
              console.log(res_data)
             
      });
    },
    selectKatalog(data){
      this.$router.push("/katalogPerpusDetile?katalogId=" + data.id);

    },

  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.getView();
  }
};
